import { createAction, createSlice } from '@reduxjs/toolkit';
import { AssetBalanceStatistics, CoreMsgTypes } from '@tassat/fred-definitions';

export interface ApiBalanceStatsState {
    [key: string]: AssetBalanceStatistics;
}

const initialState: ApiBalanceStatsState = {};

const initialLoad = createAction<{ apiBalanceStats: ApiBalanceStatsState }>('InitialLoad');
const apiBalanceStatistics = createAction<AssetBalanceStatistics>(CoreMsgTypes.AssetBalanceStatistics);
const apiBalanceStatsSlice = createSlice({
    name: 'apiBalanceStats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(initialLoad, (state, action) => {
            return {
                ...state,
                ...action.payload.apiBalanceStats
            };
        })
            .addCase(apiBalanceStatistics, (state, action) => {
                const { AssetId, IsApi } = action.payload;
                if (IsApi) {
                    state[AssetId] = {
                        ...state[AssetId],
                        ...action.payload
                    };
                }
            })
            .addDefaultCase(state => state);
    }
});

export default apiBalanceStatsSlice.reducer;